import { themeIconMap } from "@/src/utils/themeIconMap";
import store from "@/src/store";

export default {
  mounted(el, binding) {
    if (el.tagName !== "IMG") return;

    const iconName = binding.value;
    const iconConfig = themeIconMap[iconName];

    if (!iconConfig) {
      return;
    }

    el.setAttribute("data-theme-aware", "true");
    el.setAttribute("data-theme-icon", JSON.stringify(iconConfig));

    el.src = store.getters["theme/getIconForTheme"](iconConfig);
  },
};
